<template>
  <div>
    <div class="p-3">
      <BackHeader>
        <template slot="title">{{ $t('pages.contributors.title') }}</template>
      </BackHeader>
    </div>
    <div class="px-3 border-bottom">
      <ul class="list-inline mb-0 d-flex justify-content-between">
        <li>
          <a
            href="#"
            :class="[$style.filter, service.params.designations === null ? $style.active : null]"
            @click.prevent="onClick([null])"
          >
            {{ $t('pages.contributors.all') }}
          </a>
        </li>
        <li
          v-for="(filter, index) in filters"
          :key="index"
        >
          <a
            href="#"
            :class="[$style.filter, service.params.designations === filter[0] ? $style.active : null]"
            @click.prevent="onClick(filter)"
          >
            {{ filter[1] }}
          </a>
        </li>
      </ul>
    </div>
    <div class="p-3">
      <b-form
        @submit.prevent="onSearch"
      >
        <input
          v-model="service.params.query"
          type="search"
          class="form-control"
          :placeholder=" $t('pages.contributors.search_ph')"
        />
      </b-form>
    </div>

    <div
      v-bar
    >
      <div
      >
        <div
          class="px-3"
          :style="{ height: height + 'px' }"
        >
          <b-checkbox
            v-for="(user, index) in service.data"
            :key="index"
            :class="['p-3 mb-2 mr-0 card', $style.profile]"
            :value="user.uuid"
            v-model="service.contributors"
          >
            <img
              :src="user | profilePicture('small')"
              width="32"
              height="32"
              class="float-left rounded-circle mr-3 ml-5"
            />

            <h3 class="mb-1 text-truncate">{{user.name}}</h3>
            <div :class="$style.role">
              <template
                v-if="user.country"
              >
                {{user.country.name}}
                <span>•</span>
              </template>
              {{ $t('pages.contributors.items', { total: user.items_count}) }}
            </div>
            <a
              href="#"
              :class="$style.btnProfile"
              @click="onViewProfile(user.username)"
            >{{ $t('buttons.view_profile') }}</a>
          </b-checkbox>
          <div
            v-if="service.hasMorePages && !service.isLoading"
            class="mt-5 mb-6 d-flex justify-content-center"
          >
            <button
              type="button"
              class="btn btn-outline-primary"
              @click.prevent="service.fetchNextPage()"
            >{{ $t('buttons.load_more') }}
            </button>
          </div>
          <Loading
            v-if="service.isLoading"
            class="my-3"
          ></Loading>
        </div>
      </div>
    </div>

    <button
      type="button"
      :class="['btn btn-primary', $style.btnAction, isLoading ? 'disabled ajax-loading' : '']"
      @click.prevent="onSubmit"
    >
      <span v-if="!service.contributors.length">
        {{ $t('buttons.select_contributor') }}
      </span>
      <span v-else-if="service.contributors.length === 1">
        {{ $t('buttons.add_one_contributor', { name: firstContributorName}) }}
      </span>
      <span v-else-if="service.contributors.length > 1">
        {{ $t('buttons.add_contributors', { name: firstContributorName, more: service.contributors.length-1 }) }}
      </span>
    </button>
  </div>
</template>

<script>
import toPairs from 'lodash/toPairs'
import find from 'lodash/find'
import { mapGetters, mapActions } from 'vuex'
import ContributorService from '@/services/contributor'

import Loading from '@/components/loading'
import BackHeader from '@/components/ui/BackHeader'
import Platform from '@/plugin-platforms'
import { webUrl } from '@/lib/route'

import AuthMixin from '@/components/mixins/auth'

export default {
  components: {
    Loading,
    BackHeader
  },

  mixins: [AuthMixin],

  created () {
    this.service.fetch()
    this.service.contributors = this.selectedDesigner.map(user => user.uuid)

    // Set Height of the Scroll
    this.$store.commit('scroll/set', {
      appHeader: true,
      search: true,
      filters: false,
      appliedFilters: false
    })
  },

  data () {
    let service = new ContributorService()
    return {
      isLoading: false,
      service
    }
  },

  computed: {
    ...mapGetters({
      height: 'scroll/height'
    }),
    firstContributorName () {
      if (this.service.contributors.length && this.service.data.length) {
        let contributor = null

        for (let index = 0; index < this.service.contributors.length; index++) {
          const uuid = this.service.contributors[index]
          contributor = find(this.service.data, { uuid })
          if (contributor) {
            break
          }
        }

        if (contributor) {
          return contributor.first_name
        }
      }
      return null
    },
    filters () {
      return toPairs(this.$t('pages.contributors.filters'))
    }
  },

  methods: {
    ...mapActions({
      showMessage: 'message/showMessage'
    }),
    onSearch () {
      this.service.reset()
      this.service.fetch()
    },
    onClick (value) {
      this.service.reset()
      this.service.params.designations = value[0]
      this.service.fetch()
    },
    onViewProfile (value) {
      let url = webUrl('contributor', {username: value})
      Platform.openURL(url)
    },
    async onSubmit () {
      try {
        this.isLoading = true
        await this.service.addContributors()
        this.$store.dispatch('user/getSelectedDesigners')
        this.$router.push({
          name: 'icons-slug'
        })
      } catch (error) {
        this.showMessage({
          message: this.$t('messages.liked')
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.filter {
  display: block;
  color: var(--typo-3);
  font-weight: $font-weight-normal;
  border-bottom: 3px solid transparent;
  padding-bottom: 4px;

  &.active {
    color: $primary;
    border-color: $primary;
  }
}
.profile {
  display: block;

  :global {
    .custom-control-label{
      width: 100%;

      &:before, &:after {
        top: 22px;
        left: 12px;
      }
    }
  }

  .role {
    font-size: $font-size-sm;
    color: var(--typo-4);
  }

  .btnProfile {
    position: absolute;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
  }
}
.btnAction {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  border-radius: 0;
}
</style>
/// #endif
